import React from "react";

import { useIntl } from "react-intl";

import styles from "./Header.module.scss";

const Header = () => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        {intl.formatMessage({
          id: "reports.header.title",
          defaultMessage: "Reports",
          description: "Title of reports page",
        })}
      </div>
    </div>
  );
};

export default Header;
